const BorderToggleSLimSidebar = () => (
  <div className="group absolute right-0 h-full w-4 translate-x-1/2 cursor-ew-resize">
    <div className="mx-auto h-full w-[2px] bg-gray-300 transition-colors duration-300 group-hover:bg-blue-500"></div>
  </div>
)

export default BorderToggleSLimSidebar
